import { localize } from "render/context/InternationalizationContext";

const CheckinNotOpened = localize({
  en_GB: (
    <>
      Our check-in only opens 1 hour before your visit, please try again later.
    </>
  ),
  sv_SE: (
    <>
      Vår incheckning öppnar först 1 timme innan ditt besök, försök igen senare.
    </>
  ),
});

const GoBack = localize({
  en_GB: <>Go back</>,
  sv_SE: <>Tillbaka</>,
});

const Ok = localize({
  en_GB: <>Ok</>,
  sv_SE: <>Ok</>,
});

const ThanksCheckedIn = localize({
  en_GB: <>Thank you, you are now checked in</>,
  sv_SE: <>Tack, du är nu incheckad</>,
});

const WeCouldntCheckYouIn = localize({
  en_GB: <>We couldn't check you in</>,
  sv_SE: <>Vi kunde inte checka in dig</>,
});

const CheckInSuccess = {
  MoreInfoNeeded: localize({
    en_GB: <>Before we begin, we need a little more information.</>,
    sv_SE: <>Innan vi börjar behöver vi lite mer information.</>,
  }),
  CompleteProfile: localize({
    en_GB: <>Complete Your Profile</>,
    sv_SE: <>Slutför din profil</>,
  }),
  OpenBooking: localize({
    en_GB: <>Open booking</>,
    sv_SE: <>Öppna bokning</>,
  }),
  WelcomeWeAreReady: localize({
    en_GB: (
      <>
        Welcome to the health check of the future. We are ready for your visit.
      </>
    ),
    sv_SE: (
      <>Välkommen till framtidens hälsokontroll. Vi är redo för ditt besök.</>
    ),
  }),
};

export const Trans = {
  CheckinNotOpened,
  CheckInSuccess,
  GoBack,
  Ok,
  ThanksCheckedIn,
  WeCouldntCheckYouIn,
};
